module.exports = __webpack_public_path__ + "img/img_brand17.4706a9ff.jpg";